import {createSelector} from 'reselect';

import {ApplicationStoreType} from 'reducers';

import {MODULE_KEY} from '../../constants';
import {TotalsStateType} from './types';

/**
 * Return totals local state
 * @param {ApplicationStoreType} store - application store
 * @return {TotalsStateType} - totals state
 */
export const getTotalsState = (store: ApplicationStoreType): TotalsStateType =>
    store[MODULE_KEY].totals;

/**
 * Return totals is fulfilled
 * @param {ApplicationStoreType} store - application store
 * @return {boolean} - totals is fulfilled
 */
export const totalsIsFulfilled = createSelector(
    getTotalsState,
    (state): boolean => state.status === 'fulfilled',
);

/**
 * Return totals is pending
 * @param {ApplicationStoreType} store - application store
 * @return {boolean} - totals is pending
 */
export const totalsIsPending = createSelector(
    getTotalsState,
    (state): boolean => state.status === 'pending',
);
